import PosthogService from '~/services/posthog/PosthogService';

export interface IDashboardActionNeededClickedPayload {
  shiftCount: number;
}

/**
 * Fires when an office clicks the Action Needed button on the dashboard
 * Event: dental_portal:dashboard:action_needed_clicked
 */
export function fireDashboardActionNeededClicked(payload: IDashboardActionNeededClickedPayload): void {
  PosthogService.getInstance().track('dental_portal:dashboard:action_needed_clicked', {
    shift_count: payload.shiftCount,
  });
}
